import * as React from 'react';
import TtdGlobalPixel from 'analytics/ttd/components/GlobalPixel';
import MntnGlobalPixel from '../MntnGlobalPixel';
import PinterestGlobalPixel from '../PinterestGlobalPixel';
import QuoraPixel from '../QuoraPixel';

export default function GlobalTrackingPixels() {
    return (
        <>
            <MntnGlobalPixel />
            <PinterestGlobalPixel />
            <TtdGlobalPixel />
            <QuoraPixel pixelMode="global" />
        </>
    );
}
